"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCookie = exports.getCookie = exports.deleteCookie = exports.setCookie = void 0;
const util_1 = require("./util");
/**
 * Set a cookie
 */
function setCookie(key, value, config) {
    document.cookie = (0, util_1.formatCookie)(key, value, config);
}
exports.setCookie = setCookie;
/**
 * Delete a cookie
 */
function deleteCookie(key, config) {
    // We can't delete a cookie, but setting max-age to 0 deletes it
    document.cookie = (0, util_1.formatCookie)(key, '', Object.assign(Object.assign({}, config), { 'Max-Age': 0 }));
}
exports.deleteCookie = deleteCookie;
/**
 * Get a cookie's value
 */
function getCookie(key) {
    const cookies = document.cookie.split(';').map((i) => i.trim());
    for (const cookie of cookies) {
        const parts = cookie.split('=');
        if (parts.length < 2) {
            continue;
        }
        const name = parts.shift();
        if (name === key) {
            // Since we previously split on '=' we put it back in with the join.
            return parts.join('=');
        }
    }
    return undefined;
}
exports.getCookie = getCookie;
function hasCookie(key) {
    return typeof getCookie(key) !== 'undefined';
}
exports.hasCookie = hasCookie;
